import { defineStore } from 'pinia';
import { useAcvFetch } from '~~/composables/useAcvFetch';

export const useStagedJobsStore = defineStore({
  id: 'stagedJobsStore',
  state: () => {
    return {
      jobs: [],
      pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 17,
        size: 50,
        totalElements: 0,
        totalPages: 1,
      },
      currentPage: 0,
      rowsPerPage: '50',
      successfullyStaged: null,
      pendingStaged: null,
      bookedStatus: null,
      failedToStage: [],
      currentPageIndex: 0,
    };
  },
  actions: {
    async getStagedJobs() {
      const { data: content, error } = await useAcvFetch(
        `api/transport-requests/staged`,
        {
          method: 'GET',
          params: {
            page: this.currentPageIndex,
            size: this.rowsPerPage,
            sort: `asc`,
          },
        }
      );
      if (error.value) {
        if (error.value.statusCode === 403) {
          navigateTo({
            path: '/403',
            query: {
              src: 'restricted staged jobs',
            },
          });
        }

        return;
      }
      this.jobs = content.value.data.content;
      this.pagination = content.value.data.pagination;
    },
    async bookStagedJob(body, { orderId, carModel, isInstantBook, bundleId }) {
      const { error } = await useAcvFetch(
        `/api/transport-requests/bookStagedJob`,
        {
          method: 'POST',
          body,
        }
      );

      await this.getStagedJobs();
      const details = {
        orderId,
        bundleId,
        carModel,
        id: body.transportRequestId,
      };

      if (error.value) {
        this.bookedStatus = {
          ...details,
          bookedType: 'error',
        };
      } else {
        this.successfullyStaged = isInstantBook ? details : null;
        this.pendingStaged = isInstantBook ? null : details;
        this.bookedStatus = {
          ...details,
          bookedType: isInstantBook ? 'instant' : 'pending',
        };
      }
      this.failedToStage = [];
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async unstageJob(requestId) {
      await useAcvFetch(`/api/transport-requests/unstage/${requestId}`, {
        method: 'GET',
      });

      await this.getStagedJobs();
    },
    clearNotificationsLists() {
      this.successfullyStaged = null;
      this.pendingStaged = null;
      this.bookedStatus = null;
      this.failedToStage = [];
    },
    setFailedToStage(requestId) {
      this.failedToStage = requestId;
    },
  },
});
